import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";

import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import "@/components/layout/StaffLayout/StaffLayout.css";

import { useLogout } from "@/hooks/api/user.hooks.ts";

interface QuitModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QuitModal = ({ isOpen, onClose }: QuitModalProps): JSX.Element => {
  const { t } = useTranslation();

  const { mutate, isPending, isSuccess } = useLogout();

  const exit = (): void => mutate();
  const closeModal = (): void => {
    if (isPending || isSuccess) return;
    onClose();
  };

  const isButtonDisabled = isPending || isSuccess;

  return (
    <>
      <Dialog open={isOpen} onClose={closeModal} transition className={"headless-dialog"}>
        <DialogPanel
          transition
          className="headless-dialog-panel max-w-[37.5rem] space-y-6 rounded-[2rem] p-8 shadow-[0px_0px_2.875rem_#ff570830] max-lg:rounded-2xl max-lg:px-4 max-lg:py-6"
        >
          <div className={"staff-modal__header text-center"}>
            <DialogTitle as="h3" className="staff-modal__title">
              {t("auth.sign-out-title")}
            </DialogTitle>
            <p className="staff-modal__description grey">{t("auth.sign-out-message")}</p>
          </div>
          <div className="flex flex-row gap-6">
            <Button title={t("Actions.cancel")} color={"black"} disabled={isButtonDisabled} onClick={onClose}>
              {t("Actions.cancel")}
            </Button>
            <Button title={t("auth.sign-out")} disabled={isButtonDisabled} onClick={exit}>
              {t("auth.sign-out")}
            </Button>
          </div>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default QuitModal;
